const initialState = {
    prdUserId: "",
    fileUploadPath: "",
    testingUserID: "",
    testingFormID: "",
    formTitle: "",
    message: "",
    responsesList: [],
    responsesCount: 1,
    storageTotal: 0,
    createdDate: new Date().getTime(),
    modifiedDate: new Date().getTime(),
    withResponses: false,
    showAcknowledgement: false,
    showPopUp: false,
    shuffleQuestions: false,
    uploadCount: 0,
    questionsCount: {
        SHORT_TEXT: 0,
        LONG_TEXT: 0,
        EMAIL: 0,
        NUMBER: 0,
        MULTIPLE_CHOICE: 0,
        CHECKBOX_CHOICE: 0,
        DROPDOWN_CHOICE: 0,
        MULTIPLE_CHOICE_GRID: 0,
        CHECKBOX_GRID: 0,
        STAR_RATING_SCALE: 0,
        LINEAR_SCALE: 0,
        DATE: 0,
        TIME: 0,
        FILE_UPLOAD: 0,
        AGREEMENT:0,
        PICTURE_QUESTION:0,
        SIGNATURE_QUESTION:0,
        SLIDER:0,
        RANKING_CHOICE:0,
    },
    optionsCount: {
        MULTIPLE_CHOICE_ROWS: 1,
        MULTIPLE_CHOICE_COLUMNS: 1,
        CHECKBOX_CHOICE_ROWS: 1,
        CHECKBOX_CHOICE_COLUMNS: 1,
        MULTIPLE_CHOICE: 1,
        CHECKBOX_CHOICE: 1,
        DROPDOWN_CHOICE: 1,
        LINEAR_SCALE: 1,
        RANKING_CHOICE: 4,
    }
}

export const TESTING_TOOLS_ACTION_TYPES = {
    SET_PRD_USER_ID: "SET_PRD_USER_ID",
    SET_STORAGE_TOTAL: "SET_STORAGE_TOTAL",
    SET_CREATED_DATE: "SET_CREATED_DATE",
    SET_MODIFIED_DATE: "SET_MODIFIED_DATE",
    SET_RESPONSES_LIST: "SET_RESPONSES_LIST",
    SET_RESPONSES_COUNT: "SET_RESPONSES_COUNT",
    SET_FILE_UPLOAD_PATH: "SET_FILE_UPLOAD_PATH",
    SET_TESTING_USER_ID: "SET_TESTING_USER_ID",
    SET_TESTING_FORM_ID: "SET_TESTING_FORM_ID",
    SET_FORM_TITLE: "SET_FORM_TITLE",
    SET_SHUFFLE: "SET_SHUFFLE",
    SET_WITH_RESPONSES: "SET_WITH_RESPONSES",
    RESET: "RESET",
    SET_UPLOAD_COUNT: "SET_UPLOAD_COUNT",
    SET_SHOW_POPUP: 'SET_SHOW_POPUP',
    SET_MESSAGE: "SET_MESSAGE",
    SET_OPTIONS_COUNT: "SET_OPTIONS_COUNT",
    SET_QUESTIONS_COUNT: "SET_QUESTIONS_COUNT",
    SET_SHOW_ACKNOWLEDGEMENT: "SET_SHOW_ACKNOWLEDGEMENT"
}

const testingToolsReducer = (state = initialState, action) => {
    switch (action.type) {
        case (TESTING_TOOLS_ACTION_TYPES.SET_PRD_USER_ID):
            return {
                ...state,
                prdUserId: action.payload
            }
        case (TESTING_TOOLS_ACTION_TYPES.SET_TESTING_USER_ID):
            return {
                ...state,
                testingUserID: action.payload
            }
        case (TESTING_TOOLS_ACTION_TYPES.SET_STORAGE_TOTAL):
            return {
                ...state,
                storageTotal: action.payload
            }
        case (TESTING_TOOLS_ACTION_TYPES.SET_RESPONSES_LIST):
            return {
                ...state,
                responsesList: action.payload
            }
        case (TESTING_TOOLS_ACTION_TYPES.SET_RESPONSES_COUNT):
            return {
                ...state,
                responsesCount: action.payload
            }
        case (TESTING_TOOLS_ACTION_TYPES.SET_TESTING_FORM_ID):
            return {
                ...state,
                testingFormID: action.payload
            }
        case (TESTING_TOOLS_ACTION_TYPES.SET_WITH_RESPONSES):
            return {
                ...state,
                withResponses: action.payload
            }
        case (TESTING_TOOLS_ACTION_TYPES.SET_SHOW_POPUP):
            return {
                ...state,
                showPopUp: action.payload
            }
        case (TESTING_TOOLS_ACTION_TYPES.SET_UPLOAD_COUNT):
            return {
                ...state,
                uploadCount: action.payload
            }
        case (TESTING_TOOLS_ACTION_TYPES.SET_FORM_TITLE):
            return {
                ...state,
                formTitle: action.payload
            }
        case (TESTING_TOOLS_ACTION_TYPES.SET_MODIFIED_DATE):
            return {
                ...state,
                modifiedDate: action.payload
            }
        case (TESTING_TOOLS_ACTION_TYPES.SET_CREATED_DATE):
            return {
                ...state,
                createdDate: action.payload
            }
        case (TESTING_TOOLS_ACTION_TYPES.SET_QUESTIONS_COUNT):
            return {
                ...state,
                questionsCount: action.payload
            }
        case (TESTING_TOOLS_ACTION_TYPES.SET_MESSAGE):
            return {
                ...state,
                message: action.payload
            }
        case (TESTING_TOOLS_ACTION_TYPES.SET_SHUFFLE):
            return {
                ...state,
                shuffleQuestions: action.payload
            }
        case (TESTING_TOOLS_ACTION_TYPES.SET_OPTIONS_COUNT):
            return {
                ...state,
                optionsCount: action.payload
            }
        case (TESTING_TOOLS_ACTION_TYPES.SET_SHOW_ACKNOWLEDGEMENT):
            return {
                ...state,
                showAcknowledgement: action.payload
            }
        case (TESTING_TOOLS_ACTION_TYPES.SET_FILE_UPLOAD_PATH):
            return {
                ...state,
                fileUploadPath: action.payload
            }
        case (TESTING_TOOLS_ACTION_TYPES.RESET):
            return initialState
        default:
            return state
    }
}

export default testingToolsReducer
